import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ScrollText, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AmendmentNotice = ({ a }) => {
  const [ack, setAck] = useState(a?.acknowledged_at);
  if (!a) return null;
  const acknowledge = async () => {
    try {
      const token = localStorage.getItem('pas_client_token');
      const r = await axios.post(`${API}/pas-banking/credit-line/agreement/amendment/acknowledge`, {}, { headers: { Authorization: `Bearer ${token}` } });
      setAck(new Date().toISOString()); toast.success(r.data.message);
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
  };
  return (
    <div className="bg-emerald-500/10 border border-emerald-500/30 rounded-lg p-4 mb-4 text-sm" data-testid="credit-amendment-notice">
      <p className="text-emerald-300 font-semibold flex items-center gap-2 mb-1"><ScrollText className="w-4 h-4" /> {a.title}</p>
      <p className="text-slate-300 mb-2">{a.text}</p>
      <div className="flex flex-wrap items-center gap-3 text-xs">
        {a.anchor?.explorer_url && <a href={a.anchor.explorer_url} target="_blank" rel="noreferrer" className="text-emerald-400 underline flex items-center gap-1" data-testid="credit-amendment-anchor">Recorded on Base <ExternalLink className="w-3 h-3" /></a>}
        {ack ? <span className="text-slate-400" data-testid="credit-amendment-acked">Acknowledged {new Date(ack).toLocaleDateString()}</span>
          : <button onClick={acknowledge} className="px-3 py-1.5 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg" data-testid="credit-amendment-ack-btn">I've read this notice</button>}
      </div>
    </div>
  );
};
